/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypassincludes2Inputs */

const en_adminbypassincludes2 = /** @type {(inputs: Adminbypassincludes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass grants:`)
};

const de_adminbypassincludes2 = /** @type {(inputs: Adminbypassincludes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass gewährt:`)
};

/**
* | output |
* | --- |
* | "Bypass grants:" |
*
* @param {Adminbypassincludes2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypassincludes2 = /** @type {((inputs?: Adminbypassincludes2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypassincludes2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypassincludes2(inputs)
	return de_adminbypassincludes2(inputs)
});
export { adminbypassincludes2 as "adminBypassIncludes" }